import { render, staticRenderFns } from "./NewShipmentOnFast.vue?vue&type=template&id=17d2c716&scoped=true"
import script from "./NewShipmentOnFast.vue?vue&type=script&lang=js"
export * from "./NewShipmentOnFast.vue?vue&type=script&lang=js"
import style0 from "./NewShipmentOnFast.vue?vue&type=style&index=0&id=17d2c716&prod&scoped=true&lang=css"
import style1 from "./NewShipmentOnFast.vue?vue&type=style&index=1&id=17d2c716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2c716",
  null
  
)

export default component.exports